
import axios from '@/utils/request'
/** 
**/
//红包列表
export const getBonusList = (params) => {
  return axios.request({
    url: 'v1/bonus/index',
    method: 'get',
    params
  })
};
/** 
**/
//红包关联列表
export const getBonusRelationList = (params) => {
  return axios.request({
    url: 'v1/bonus/relation',
    method: 'get',
    params
  })
};

/** 
**/
//创建红包
export const createBonus = (data) => {
  return axios.request({
    url: 'v1/bonus/save',
    method: 'post',
    data
  })
};
/** 
**/
//修改红包
export const editBonus = (data) => {
  return axios.request({
    url: 'v1/bonus/update',
    method: 'post',
    data
  })
};

/** 
**/
//修改红包状态
export const statusBonus = (data) => {
  return axios.request({
    url: 'v1/bonus/state',
    method: 'post',
    data
  })
};
/** 
**/
//删除红包
export const delBonus = (data) => {
  return axios.request({
    url: 'v1/bonus/delete',
    method: 'post',
    data
  })
};

//补发红包
export const reissueBonus = (data) => {
  return axios.request({
    url: 'v1/bonus/sendBonus',
    method: 'post',
    data
  })
};

//补发累计红包
export const reissueUserBonus = (data) => {
  return axios.request({
    url: 'v1/user_balance/sendBonus',
    method: 'post',
    data
  })
};


/** 
**/
//红包详情
export const getBonusDetail = (params) => {
  return axios.request({
    url: 'v1/bonus/detail',
    method: 'get',
    params
  })
};
//红包发放明细
export const getBonusSendList = (params) => {
  return axios.request({
    url: 'v1/bonus/sendList',
    method: 'get',
    params
  })
};

 //代发红包明细
export const getUserBalance = (params)=>{
  return axios.request({
     url: 'v1/user_balance/index',
     method: 'get',
     params
   })
 };

 
 //代发提现红包明细
export const getUserBalanceList = (params)=>{
  return axios.request({
     url: 'v1/user_balance/send_bonus_list',
     method: 'get',
     params
   })
 };
